/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

export interface DataQuery {
  filter?: FilterExpression;
  sort?: SortExpression;
  include?: string[];
  exclude?: string[];
  skip?: number;
  limit?: number;
  distinct?: boolean;
  required?: boolean;
  extensions?: boolean;
  references?: ReferenceExpression | Array<string | ReferenceExpression> | boolean;
  arguments?: ArgumentExpression;
}

export interface FilterExpression {
  [fieldKey: string]: any | { [operator: string]: any } | Array<FilterExpression>;
}

export type SortExpression = string | SortTerm | Array<string | SortTerm>;

export interface SortTerm {
  [fieldKey: string]: SortOrder
}

export type SortOrder = 'asc' | 'desc';

export class SortOrders {
  static readonly ASC: SortOrder = 'asc';
  static readonly DESC: SortOrder = 'desc';
}

export interface ReferenceExpression {
  // query -> load referenced entities with query
  // true, undefined -> load referenced entities with default query
  // false, null -> do not load referenced entities
  [field: string]: DataQuery | boolean | undefined | null;
}


export interface ArgumentExpression {
  [parameterKey: string]: any;
}
